export enum SettingAudience {
	Tenant = 'tenant',
	User = 'user',
}

export enum SettingValueType {
	String = 'string',
	Int = 'int',
	Bool = 'bool',
	Double = 'double',
}

export enum SettingType {
	RadioChoice = 'radioChoice',
	ComboBoxChoice = 'comboBoxChoice',
	OnOff = 'onOff',
	SingleValue = 'singleValue',
}

export interface SettingDefinition {
	description?: string;
	audience: SettingAudience;
	valueType: SettingValueType;
	type: SettingType;
}

export interface SettingValue {
	key: string;
	targetRID: string;
	value?: any;
	definition?: SettingDefinition;
}

export interface UpdateSettingValueRequest {
	key: string;
	value?: any;
}
